import React from 'react';

import './styles.scss';

interface SpinnerVariants {
  withText?: boolean;
  textValue?: string;
}

export const Spinner = ({ withText = false, textValue }: SpinnerVariants) => {
  return (
    <div className="spinner-container">
      <div className="spinner" />
      {withText && <p className="spinner-text">{textValue}</p>}
    </div>
  );
};
